__turbopack_context__.v({
  "appWalletAvatar": "AppWallet-module-scss-module__1Q8Mhq__appWalletAvatar",
  "appWalletCard": "AppWallet-module-scss-module__1Q8Mhq__appWalletCard",
  "blurry": "AppWallet-module-scss-module__1Q8Mhq__blurry",
  "importWalletWordInput": "AppWallet-module-scss-module__1Q8Mhq__importWalletWordInput",
  "modalContent": "AppWallet-module-scss-module__1Q8Mhq__modalContent",
  "modalHeader": "AppWallet-module-scss-module__1Q8Mhq__modalHeader",
  "newWalletInput": "AppWallet-module-scss-module__1Q8Mhq__newWalletInput",
  "phrase": "AppWallet-module-scss-module__1Q8Mhq__phrase",
  "textDanger": "AppWallet-module-scss-module__1Q8Mhq__textDanger",
  "textSuccess": "AppWallet-module-scss-module__1Q8Mhq__textSuccess",
});
